import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, ElementRef, input, Input, viewChild, ViewChild } from '@angular/core';

@Component({
  selector: 'app-content-wrapper',
  templateUrl: './content-wrapper.component.html',
  styleUrls: ['./content-wrapper.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedLayoutContentWrapperComponent {
  readonly wrapperClass = input<string>('', { alias: 'wrapper-class' });
  readonly leftClass = input<string>('', { alias: 'left-class' });
  readonly rightClass = input<string>('', { alias: 'right-class' });

  readonly contentWrapperRef = viewChild('contentWrapperRef', { read: ElementRef<HTMLElement> });
  readonly sidePanelRef = viewChild('sidePanelRef', { read: ElementRef<HTMLElement> });

  readonly hasSidePanel = computed(() => !!this.sidePanelRef()?.nativeElement.childNodes.length);
}
